import React from 'react';

const DietRecommendarions = ({ data }) => {

    // Extract necessary data
    const { DietRecommendationList = [], patientDetails = {} } = data?.data || {};
    // Sort LifeStyleList by Priority in descending order 
    const sortedDietReco = DietRecommendationList.sort((a, b) => a.Priority - b.Priority);
    // Function to construct image URL based on the group name
    const getImageUrl = (imageBaseUrl, groupName) => {
        const imageName = groupName.toLowerCase().replace(/\s+/g, '-') + '.png';
        return `${imageBaseUrl}diet/${imageName}`;
    };
    // Handle image error fallback
    const handleImageError = (e) => {
        e.target.src = `${e.target.src.split('/diet/')[0]}/diet/default.png`;
    };

    // Check if diet's gender matches patient's gender
    const isGenderMatch = (dietGender) => {
        return (
            (patientDetails.Gender === 'Male' && dietGender === 'M') ||
            (patientDetails.Gender === 'Female' && dietGender !== 'M') ||
            !dietGender
        );
    };

    return (
        <>
            <div className="col-12 mt-2 mb-5 text-center">
                <h2 className="panel-name" >Do’s and Don’ts </h2>
            </div>
            <div className="col-12 mb-2">
                <h2 className="sub-title">Hello {patientDetails.PatientName}, </h2>
            </div>

            <div className="col-12 desc mb-2 " style={{ marginBottom: 10 + 'px', fontWeight: 500 }}>
                Here are some personalised recommendations for you on your diet and lifestyle
            </div>
            { sortedDietReco.length > 0 ? (
                <>
                    <div className="col-12">
                        <span className="recom-tile">Diet <span>Recommendations</span></span>
                    </div>
                    <div className="col-12">
                        <div className="row justify-content-center recomandation-wrapper1 alternate">
                            {sortedDietReco.map((diet, index) => {
                                  if (!isGenderMatch(diet.Gender)) return null;
                                  const imageUrl = getImageUrl(diet.ImageUrl, diet.Groups);
                                return (
                                    <div key={index} className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 d-flex" >
                                        <div className="card-wrapper">
                                            <div className="rec-image-wrapper">
                                                <img alt={diet.Name} src={imageUrl} onError={handleImageError}  />
                                            </div>
                                            <h2 className="rec-title">{diet.Name}</h2>
                                            <div className="rec-desc">
                                                {diet.Description}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className='col-12'>
                        <p style={{ marginTop: 0 + 'px', fontSize: 13 + 'px', lineHeight: 140 + '%' }}>Diet consultations are based on blood reports focussing on your specific health markers. For a comprehensive dietary plan, other factors such as lifestyle, medical history, and physical condition must be considered. <b>Doctors’ consultation recommended for a personalised approach.</b></p>
                    </div>
                </>
            ) : (' ')}
        </>
    )
}

const LifeStyleRecommendations = ({ data }) => {
    // Extract necessary data
    const { LifeStyleList = [], patientDetails = {} } = data?.data || {};
    // Sort LifeStyleList by Priority in descending order 
    const sortedLifestyleReco = LifeStyleList.sort((a, b) => a.Priority - b.Priority);
    // Function to construct image URL based on the group name
    const getImageUrl = (imageBaseUrl, groupName) => {
        const imageName = groupName.toLowerCase().replace(/\s+/g, '-') + '.png';
        return `${imageBaseUrl}lifestyle/${imageName}`;
    };
    // Handle image error fallback
    const handleImageError = (e) => {
        e.target.src = `${e.target.src.split('/lifestyle/')[0]}/lifestyle/default.png`;
    };

    // Check if lifestyle's gender matches patient's gender
    const isGenderMatch = (lifestyleGender) => {
        return (
            (patientDetails.Gender === 'Male' && lifestyleGender === 'M') ||
            (patientDetails.Gender === 'Female' && lifestyleGender !== 'M') ||
            !lifestyleGender
        );
    };

    return (
        <>
            {sortedLifestyleReco.length > 0 ? (
                <>
                    <div className="col-12 mt-5">
                        <span className="recom-tile">Lifestyle <span>Recommendations</span></span>
                    </div>
                    <div className="col-12">
                        <div className="row justify-content-center recomandation-wrapper1 alternate">
                            {sortedLifestyleReco.map((lifestyle, index) => {
                                if (!isGenderMatch(lifestyle.Gender)) return null;

                                const imageUrl = getImageUrl(lifestyle.ImageUrl, lifestyle.Groups);

                                return (
                                    <div key={index} className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 d-flex">
                                        <div className="card-wrapper">
                                            <div className="rec-image-wrapper">
                                                <img
                                                    alt={lifestyle.Name}
                                                    src={imageUrl}
                                                    onError={handleImageError}
                                                />
                                            </div>
                                            <h2 className="rec-title">{lifestyle.Name}</h2>
                                            <div className="rec-desc">{lifestyle.Description}</div>
                                        </div>
                                    </div>
                                );

                            }
                            )}
                        </div>
                    </div>
                </>
            ) : (' ')}
            <div className="col-12 mb-4">
                <div style={{ marginTop: 20 + 'px', fontSize: 13 + 'px', lineHeight: 140 + '%' }}>
                    By making these adjustments, you can significantly improve your overall health and reduce the risks associated with his current lifestyle choices. Consistency and gradual progress in adopting healthier habits will lead to long-term benefits for your well-being.
                </div>
            </div>
        </>
    )
}

export { DietRecommendarions, LifeStyleRecommendations };
